import { CriteriaType, CriterionV1 } from '@csp/dmdp-api-common-dto';
import { UserCriteriaFieldType } from '@csp/dmdp-api-user-dto';

export const createFieldCriterionEq = (field: UserCriteriaFieldType, value: string): CriterionV1 => ({
  fieldCriterion: {
    type: CriteriaType.EQ,
    field,
    values: [value],
  },
});

export const createFieldCriterionIn = (field: UserCriteriaFieldType, values: string[]): CriterionV1 => ({
  fieldCriterion: {
    type: CriteriaType.IN,
    field,
    values,
  },
});

export const createFieldCriterionLike = (field: UserCriteriaFieldType, value: string): CriterionV1 => ({
  fieldCriterion: {
    type: CriteriaType.LIKE,
    field,
    values: [value],
  },
});
